/*
*   File : alphabasket-slider.js
*   Author : https://evoqins.com
*   Description : Slider component of alpha basket
*   Integrations : NA
*   Version : 1.0.0
*/

import React, { forwardRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

//Custom component
import { AlphaBasketCard } from '../Cards';

const AlphaBasketSlider = forwardRef((props, ref) => {
    return (
        <Swiper ref={ref}
            // slidesPerView={2.75}
            spaceBetween={16}
            navigation={true}
            className='z-0'
            modules={[Navigation]}
            mousewheel={true}
            breakpoints={{
                768: {   // when window width is >= 576px
                    slidesPerView: 2.75,
                    spaceBetween: 16,
                },
                576: {   // when window width is >= 576px
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                400: {   // when window width is >= 400px
                    slidesPerView: 1.2,
                    spaceBetween: 8,
                },
                320: {   // when window width is >= 320px
                    slidesPerView: 1,
                    spaceBetween: 8,
                },
            }}>

            {
                props.data.map((item, key) => (
                    <SwiperSlide key={key}>
                        <AlphaBasketCard product={item}
                            // category={item.strategy_type === "alpha-basket" ? "alphaBasket" : "alphaBasketPro"}
                            category={item.strategy_type === "alpha-basket" ? 1 : 2}
                            handleClick={() => props.handleClick(item.strategy_id)} />
                    </SwiperSlide>
                ))
            }

        </Swiper>
    )
});

export default AlphaBasketSlider;
